import React, { useState, useEffect } from 'react';
import api from '@/lib/api';
import { MapPin, CheckCircle, XCircle, Clock, Path } from '@phosphor-icons/react';

export default function MRVisitsPage() {
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getVisits().then(r => { setVisits(r.data); setLoading(false); });
  }, []);

  const verified = visits.filter(v => v.verified).length;
  const unverified = visits.filter(v => !v.verified).length;

  return (
    <div className="space-y-4">
      <div className="px-4 pt-4">
        <h2 className="text-lg font-extrabold tracking-tight" style={{ fontFamily: 'Manrope, sans-serif', color: '#0A2540' }}>
          Visit Log
        </h2>
        <p className="text-[10px] font-medium" style={{ color: '#8A94A6' }}>{visits.length} visits logged</p>
      </div>

      {/* Stats */}
      <div className="px-4 grid grid-cols-2 gap-3">
        <div className="p-3.5 rounded-xl border flex items-center gap-3" style={{ background: '#FFFFFF', borderColor: '#E2E4E9' }}>
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: '#34C75910' }}>
            <CheckCircle size={20} weight="fill" style={{ color: '#34C759' }} />
          </div>
          <div>
            <p className="text-lg font-extrabold" style={{ color: '#34C759', fontVariantNumeric: 'tabular-nums' }}>{verified}</p>
            <p className="text-[9px] font-bold uppercase" style={{ color: '#8A94A6' }}>Verified</p>
          </div>
        </div>
        <div className="p-3.5 rounded-xl border flex items-center gap-3" style={{ background: '#FFFFFF', borderColor: '#E2E4E9' }}>
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: '#FF3B3010' }}>
            <XCircle size={20} weight="fill" style={{ color: '#FF3B30' }} />
          </div>
          <div>
            <p className="text-lg font-extrabold" style={{ color: '#FF3B30', fontVariantNumeric: 'tabular-nums' }}>{unverified}</p>
            <p className="text-[9px] font-bold uppercase" style={{ color: '#8A94A6' }}>Unverified</p>
          </div>
        </div>
      </div>

      {/* Visit List */}
      <div className="px-4 space-y-2">
        {loading ? (
          <p className="text-center py-12" style={{ color: '#8A94A6' }}>Loading...</p>
        ) : visits.length === 0 ? (
          <div className="p-10 text-center rounded-xl border" style={{ background: '#FFFFFF', borderColor: '#E2E4E9' }}>
            <Path size={48} weight="duotone" style={{ color: '#E2E4E9' }} className="mx-auto mb-3" />
            <p className="text-sm font-semibold" style={{ color: '#0A2540' }}>No visits logged yet</p>
            <p className="text-xs mt-1" style={{ color: '#8A94A6' }}>Go to Beat Plan to log your first visit</p>
          </div>
        ) : visits.map((v, i) => (
          <div key={i} className="p-3.5 rounded-xl border flex items-center gap-3" style={{ background: '#FFFFFF', borderColor: '#E2E4E9' }}>
            <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0"
              style={{ background: v.verified ? '#34C75910' : '#FF3B3010' }}>
              {v.verified ?
                <CheckCircle size={22} weight="fill" style={{ color: '#34C759' }} /> :
                <XCircle size={22} weight="fill" style={{ color: '#FF3B30' }} />
              }
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold truncate" style={{ color: '#0A2540' }}>{v.doctor_name}</p>
              <div className="flex items-center gap-2 mt-0.5">
                <span className="text-[10px] flex items-center gap-0.5" style={{ color: '#8A94A6' }}>
                  <Clock size={10} /> {v.visited_at?.slice(0, 10)}
                </span>
                <span className="text-[10px] flex items-center gap-0.5" style={{ color: '#8A94A6' }}>
                  <MapPin size={10} /> {v.distance_km} km
                </span>
              </div>
              {v.notes && <p className="text-[10px] mt-1 truncate" style={{ color: '#8A94A6' }}>{v.notes}</p>}
            </div>
            <span className="px-2 py-1 rounded-lg text-[9px] font-bold uppercase shrink-0"
              style={{
                background: v.verified ? '#34C75910' : '#FF3B3010',
                color: v.verified ? '#34C759' : '#FF3B30'
              }}>
              {v.verified ? 'Verified' : 'Failed'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
